import { render, staticRenderFns } from "./flix_glyphicon.vue?vue&type=template&id=c6429916"
import script from "./flix_glyphicon.vue?vue&type=script&lang=js"
export * from "./flix_glyphicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports